import type * as React from "react";
import { useMemo } from "react";

import { MultiSelect, type OptionValue } from "@/components/ui/multi-select";
import { StatusBadge } from "@/features/invoices-table/cells/status-badge";
import { cn } from "@/lib/utils";
import { Check, CircleCheck, Download, Eye } from "lucide-react";

export function CounterpartyStatusFilter({
  values,
  onChange,
}: {
  values: string[];
  onChange: (values: string[]) => void;
}) {
  const options = useMemo(
    () => [
      {
        label: "",
        value: "new",
        icon: ({ className }: { className?: string }) => (
          <StatusBadge
            icon={Eye}
            iconColor="text-orange-800"
            textColor="text-orange-800"
            containerColor="bg-orange-100 border border-orange-200"
          >
            Zu Prüfen
          </StatusBadge>
        ),
      },
      {
        label: "",
        value: "confirmed",
        icon: ({ className }: { className?: string }) => (
          <StatusBadge
            icon={Check}
            iconColor="text-green-800"
            textColor="text-green-800"
            containerColor="bg-green-100 border border-green-200"
          >
            Geprüft
          </StatusBadge>
        ),
      },
      {
        label: "",
        value: "exported",
        icon: ({ className }: { className?: string }) => (
          <StatusBadge
            icon={CircleCheck}
            iconColor="text-indigo-800"
            textColor="text-indigo-800"
            containerColor="bg-indigo-100 border border-indigo-200"
          >
            Exportiert
          </StatusBadge>
        ),
      },
      {
        label: "",
        value: "imported",
        icon: ({ className }: { className?: string }) => (
          <StatusBadge
            icon={Download}
            iconColor="text-gray-800"
            textColor="text-gray-800"
            containerColor="bg-gray-100 border border-gray-200"
          >
            Importiert
          </StatusBadge>
        ),
      },
    ],
    [],
  );

  const handleValueChange = (newValues: OptionValue[]) => {
    onChange(newValues as string[]);
  };

  return (
    <MultiSelect
      options={options}
      mode="multiple"
      defaultValue={values}
      onValueChange={handleValueChange}
      placeholder="Status"
      className={cn(
        "w-auto",
        values.length > 0 ? "bg-secondary" : "text-muted-foreground",
      )}
      enableClear
    />
  );
}
